import './CircleBadge-87549d20.css';

var styles = {"CircleBadge":"prc-CircleBadge-CircleBadge-AFS8i","CircleBadgeIcon":"prc-CircleBadge-CircleBadgeIcon-sUrCi"};

export { styles as default };
